import React, { useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import "./css/Dashboard.css";

export default function Dashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [markets, setMarkets] = useState([]);
  const [loadingMarkets, setLoadingMarkets] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/get_markets.php`)
      .then((res) => res.json())
      .then((data) => {
        if (data.markets) {
          setMarkets(data.markets);
        }
      })
      .finally(() => setLoadingMarkets(false));
  }, []);

  const handleMarketClick = (marketName) => {
    navigate(`/market/${marketName.toLowerCase().replace(/\s+/g, '-')}`);
  };

  const initial = user?.name ? user.name.trim().charAt(0).toUpperCase() : "U";

  return (
    <div className="dash-page">
      <div className="dash-topbar">
        <div className="dash-avatar">{initial}</div>

        <div className="dash-welcome-wrap">
          <div className="dash-welcome-label">Welcome back</div>
          <div className="dash-welcome-name">{user?.name || "Guest"}</div>
        </div>

        <button
          className="dash-logout-btn"
          onClick={() => {
            logout();
            navigate("/");
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
            <path d="M16 17l5-5-5-5" />
            <path d="M21 12H9" />
          </svg>
          Logout
        </button>
      </div>

      <div className="dash-content">
        <div className="dash-trust-banner">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z" />
            <path d="M9 12l2 2 4-4" />
          </svg>
          <div className="dash-trust-text">
            <strong>Trusted &amp; Verified</strong> — live load data updated in real time for every market.
          </div>
        </div>

        <div className="dash-section-title">Select a Market</div>

        {loadingMarkets ? (
          <div className="dash-market-grid">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="dash-skeleton-card" />
            ))}
          </div>
        ) : markets.length === 0 ? (
          <div className="dash-empty-state">No markets available right now.</div>
        ) : (
          <div className="dash-market-grid">
            {markets.map((market, index) => (
              <button
                key={index}
                className="dash-market-card"
                onClick={() => handleMarketClick(market)}
              >
                <div className="dash-market-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 3v18h18" />
                    <path d="M7 15l4-5 3 3 5-7" />
                  </svg>
                </div>
                <div className="dash-market-name">{market.toUpperCase()}</div>
                <div className="dash-market-sub">View live load</div>
              </button>
            ))}
          </div>
        )}

        <div className="dash-actions">
          <a className="dash-action-link" href="/add-highlight">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M23 4v6h-6" />
              <path d="M1 20v-6h6" />
              <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
            </svg>
            Refresh Highlights
          </a>
        </div>
      </div>
    </div>
  );
}
